import React from 'react';
import { ReactComponent as StepCompleteIcon } from '../../../assets/images/svg/step-header-complete.svg';
import './customGuideline.less';

interface StepItem {
  key: string;
  title: string;
  description: string;
  step: number;
  active: boolean;
  completed: boolean;
  header: string;
  subStep?: {
    key: string;
    step: number;
    active: boolean;
    completed: boolean;
    header: string;
  };
}

interface StepHeaderProps {
  guidelineItems: StepItem[];
  stepKey?: string; // Step key to render
  isOnMailPayer?: boolean;
}

const StepHeader: React.FC<StepHeaderProps> = ({ guidelineItems, stepKey, isOnMailPayer}: any): any => {
  // Total steps now take into account subSteps as separate steps
  const totalSteps = guidelineItems?.reduce((count: any, item: any): number => count + (item?.subStep ? 1 : 0),
  isOnMailPayer ? guidelineItems?.length : guidelineItems?.length - 1);

  // Find the current stepItem or subStep based on the stepKey
  const stepItem = guidelineItems?.find((item: any): any =>
    item?.key === stepKey || item?.subStep?.key === stepKey,
  );

  // Sort the steps to ensure they're in correct order
  const sortedSteps = guidelineItems?.flatMap((item: any): any =>
    item?.subStep ? [item, item?.subStep] : item)?.sort((a: any, b: any): any => a?.step - b?.step);

  // Find the active step
  const activeStepIndex = sortedSteps?.findIndex((item: any): any => !item?.completed);

  if (!stepItem || activeStepIndex === -1) {
    return null;
  }

  const activeStep = sortedSteps[activeStepIndex];

  const renderStepHeader = (): any => {
    const isSubStep = stepItem?.subStep && stepItem?.subStep.key === stepKey;
    const currentStep = isSubStep ? stepItem?.subStep : stepItem;

    // If current step is completed
    if (currentStep?.completed) {
      return (
        <div key={currentStep?.key} className="step-header-container centre-align">
          <span><StepCompleteIcon /></span>
          <span className="step-header-text">{currentStep?.header}</span>
        </div>
      );
    }

    // Render active step header
    if (currentStep?.step === activeStep?.step) {
      return (
        <div key={currentStep?.key} className="step-header-container">
          <span className="step-header-count">
            Step&nbsp;<span className="step-count-number">{currentStep?.step} / {totalSteps}</span>
          </span>
          <span className="step-header-text">{currentStep?.header}</span>
        </div>
      );
    }

    return null;
  };

  return <div>{renderStepHeader()}</div>;
};

export default StepHeader;
